
// src/config/routes/public.routes.ts
import { BarChartBig, FunctionSquare, Hexagon, Monitor, Network, ScrollText, User } from 'lucide-react';
import { lazy } from 'react';
import { RouteConfig } from 'src/types/route-config.types';

export const publicRoutes: RouteConfig[] = [
  // {
  //   name: "auth",
  //   path: "/auth",
  //   showInSideNav: false,
  //   access: ["*"], // Accessible to everyone
  //   component: lazy(() => import('src/navigations/auth/AuthLayout')),
  //   breadcrumbPath: ["auth"],
  //   icon: "signup",
  //   order: 2,
  //   children: [
  //     {
  //       name: "auth",
  //       path: "login",
  //       showInSideNav: false,
  //       access: ["*"], // Accessible to everyone
  //       component: lazy(() => import('src/pages/auth/login/LoaginPage')),
  //       breadcrumbPath: ["auth", "login"],
  //       icon: "signup",
  //       order: 2,
  //       meta: {
  //         title: "Create Your Account",
  //         description: "Join our platform and get started today",
  //       }
  //     },
  //     {
  //       name: "auth",
  //       path: "signup",
  //       showInSideNav: false,
  //       access: ["*"], // Accessible to everyone
  //       component: lazy(() => import('src/components/auth/signup/SignupLayout')),
  //       breadcrumbPath: ["auth", "signup"],
  //       icon: "signup",
  //       order: 2,
  //       children: [
  //         {
  //           name: "Sign up Form",
  //           path: "",
  //           showInSideNav: false,
  //           access: ["*"], // Accessible to everyone
  //           component: lazy(() => import('src/pages/auth/signup/SignUpPage')),
  //           breadcrumbPath: ["auth", "signup"],
  //           icon: "signup",
  //           order: 2,
  //           meta: {
  //             title: "Create Your Account",
  //             description: "Join our platform and get started today",
  //           }
  //         },
  //         {
  //           name: "otp-verification",
  //           path: "verify",
  //           showInSideNav: false,
  //           access: ["*"], // Accessible to everyone
  //           component: lazy(() => import('src/pages/auth/signup/OtpVerification')),
  //           breadcrumbPath: ["auth", "signup", "verify"],
  //           icon: "signup",
  //           order: 2,
  //           meta: {
  //             title: "Create Your Account",
  //             description: "Join our platform and get started today",
  //           }
  //         },
  //       ],
  //       meta: {
  //         title: "Create Your Account",
  //         description: "Join our platform and get started today",
  //       }
  //     },
  //   ],
  //   meta: {
  //     title: "Create Your Account",
  //     description: "Join our platform and get started today",
  //     requiresAuth: false,
  //     layout: "public",
  //     analytics: {
  //       category: "Public",
  //       action: "Signup_View"
  //     }
  //   }
  // },
  {
    name: "Home",
    path: "/home",
    component: lazy(() => import('src/pages/home/HomePage')),
    showInSideNav: true,
    access: ["*"], // Accessible to everyone
    breadcrumbPath: ["Home"],
    icon: "home",
    order: 1,
    meta: {
      title: "Welcome to Our Platform",
      description: "Your trusted partner for consumer services",
      requiresAuth: false,
      layout: "public",
      analytics: {
        category: "Public",
        action: "Home_View"
      }
    }
  },


  {
        name: "Opt Energy New Concent",
        path: "/opt-energy-new-concent",
        component: lazy(() => import('src/pages/opt-energy-concent/ConsentPage')),
        showInSideNav: false,
        sideNavGroupName: "",
        access: ["*"],
        breadcrumbPath: ["Opt Energy New Concent"],
        // icon: <User className='h-2 w-2' />,
        isDefaultFor: ["consumer"],
        order: 1,

    },

  // To be removed after testing
     {
        name: "Terms And Conditions",
        path: "/terms-and-conditions",
        component: lazy(() => import('src/pages/TermsAndConditions/TermsAndConditionsPage')),
        showInSideNav: true,
        sideNavGroupName: "Reports",
        access: ["*"],
        breadcrumbPath: ["TermsAndConditions"],
        // icon: <User className='h-2 w-2' />,
        order: 2.1,
        meta: {
            title: "",
            description: ""
        }
    },
  // {
  //   name: "Billing",
  //   path: "/billing",
  //   component: lazy(() => import('src/pages/billing/Index')),
  //   showInSideNav: true,
  //   access: ["*"], // Accessible to everyone
  //   breadcrumbPath: ["Billing"],
  //   icon: "home",
  //   order: 1,
  //   meta: {
  //     title: "Welcome to Our Platform",
  //     description: "Your trusted partner for consumer services",
  //     requiresAuth: false,
  //     layout: "public",
  //     analytics: {
  //       category: "Public",
  //       action: "Home_View"
  //     }
  //   }
  // },

  

];